'use client';

import { History } from '@repo/types';
import { FieldResolver } from '@repo/ui/lib/utils/field-label-resolver';
import { TreePine } from 'lucide-react';

interface TravauxAbattageProps {
  history: History;
  resolver: FieldResolver;
}

export function TravauxAbattage({ history, resolver }: TravauxAbattageProps) {
  const abattageLabel = history.abattage ? resolver.getFieldLabel('abattage') || history.abattage : 'Non renseigné';
  const hasValue = !!history.abattage;

  return (
    <div className="space-y-2">
      <label className="text-sm font-semibold text-gray-900 flex items-center gap-2">
        <TreePine className="h-4 w-4 text-primary" />
        Abattage
      </label>
      <div className={`bg-gray-50 border rounded-lg px-4 py-3 min-h-[2.5rem] flex items-center transition-all duration-200 ${
        hasValue ? 'border-gray-200 hover:border-gray-300 hover:bg-gray-100/50' : 'border-gray-100'
      }`}>
        <span className={`text-sm ${!hasValue ? 'text-muted-foreground italic' : 'text-gray-900 font-medium'}`}>
          {abattageLabel}
        </span>
      </div>
    </div>
  );
}
